/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';

import { makeStyles, Typography } from '@material-ui/core';

import IconCloseRound from '../../assets/images/ic-close-round.svg';
import LoadingButton from '../common/LoadingButton';

const useStyles = makeStyles((theme) => ({
  button: {
    fontSize: '14px',
  },
  buttonsContainer: {
    display: 'flex',
    gap: '10px',
    padding: '0 40px 22px',
  },
  closeIcon: {
    cursor: 'pointer',
    height: '24px',
    width: '24px',
  },
  closeIconContainer: {
    textAlign: 'right',
    width: '100%',
  },
  container: {
    background: '#FFF',
    padding: '30px',
    width: 'auto',
    [theme.breakpoints.up('md')]: {
      width: '378px',
    },
  },
  description: {
    color: '#999999',
    fontSize: '12px',
    lineHeight: '18px',
    marginBottom: '30px',
    marginTop: '12px',
  },
  titleContainer: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
  },
  typographyTitle: {
    color: '#172B4D',
    fontSize: '16px',
    fontWeight: '700',
    lineHeight: '24px',
    textAlign: 'center',
  },
}));

export default ({ openNormalRecording, onCloseIconClick, onConfirm }) => {
  const classes = useStyles();

  const handleCloseIconClick = () => {
    if (onCloseIconClick) onCloseIconClick();
  };

  const handleCancelClick = () => {
    if (openNormalRecording) openNormalRecording();
  };

  const handleAiRecordingClick = () => {
    if (onConfirm) onConfirm();
  };

  return (
    <div className={classes.container}>
      <div className={classes.closeIconContainer}>
        <img onClick={handleCloseIconClick} src={IconCloseRound} alt="close icon" className={classes.closeIcon} />
      </div>

      <div className={classes.contentContainer}>
        <div className={classes.titleContainer}>
          <Typography className={classes.typographyTitle}>
            Would you like to use <br />
            ‘AI-powered video recording’?
          </Typography>
        </div>

        <Typography className={classes.description} align="center">
          Using ‘AI-powered video recording’ <br />
          will also automatically create a written report
        </Typography>

        <div className={classes.buttonsContainer}>
          <LoadingButton onClick={handleCancelClick} className={classes.button} fullWidth size="large" variant="outlined" color="primary">
            No
          </LoadingButton>
          <LoadingButton onClick={handleAiRecordingClick} className={classes.button} fullWidth size="large" variant="contained" color="primary">
            Yes
          </LoadingButton>
        </div>
      </div>
    </div>
  );
};
